import React from 'react';
import {Flex} from '/app/src/component';
import Header from "./Header"

const bodyStyle = {
    color: "Black_M",
    padding: "30px 0px 40px 0px",
    width: "600px",
    fontSize: "20px"
}

const FileSizeUpgrade = ({text}) => (
    <Flex column  hAlignContent="center" >
        <Flex>
            <Header
                icon={"/images/Upload.svg"}
                text={"Filen du försökte skicka är för stor."}/>
        </Flex>
        <Flex {...bodyStyle}>
            {text}
        </Flex>
    </Flex>
)

export default FileSizeUpgrade;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/FileSizeUpgrade.js